<template>
  <div class="big">
    <el-dialog
      title="编辑养生方"
      :visible.sync="dialogShow"
      width="1000px"
      style="text-align: left"
      top="50px"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="content">
        <el-form
          :model="ruleForm"
          :inline="true"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm myform"
        >
          <div class="itemtitle">
            药房名称
            <span style="margin-left: 30px; font-weight: 400">
              {{ hospitalName }}
            </span>
          </div>

          <div class="itemtitle">养生方属性</div>
          <el-form-item label="养生方编号">
            <el-input
              v-model="ruleForm.oil_code"
              placeholder="请输入"
              maxlength="20"
              class="myinput"
            ></el-input>
          </el-form-item>
          <el-form-item label="养生方名称" prop="oil_name">
            <el-input
              v-model="ruleForm.oil_name"
              placeholder="请输入"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item label="规格">
            <el-input
              v-model="ruleForm.oil_spec"
              placeholder="请输入"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item label="单位">
            <el-input
              v-model="ruleForm.oil_unit"
              placeholder="请输入"
              class="myinput"
            ></el-input>
          </el-form-item>
          <el-form-item prop="cost_price" label="成本价">
            <el-input
              v-model="ruleForm.cost_price"
              placeholder="请输入"
              class="myinput"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="price" label="销售价">
            <el-input
              v-model="ruleForm.price"
              placeholder="请输入"
              class="myinput"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>
          <el-form-item label="重量" prop="weight">
            <el-input-number
              v-model="ruleForm.weight"
              :step="0.1"
              step-strictly
              :min="1"
              label="养生方总重量"
              :controls="false"
            ></el-input-number>
            <span style="margin-left: 5px">g</span>
          </el-form-item>
          <el-form-item
            label="养生方分类"
            style="margin-left: 155px"
            prop="category_id"
          >
            <el-select
              v-model="ruleForm.category_id"
              multiple=""
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="index"
                :label="item.category_name"
                :value="item.category_id"
                :disabled="item.is_visible == 0"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="itemtitle">配方信息</div>

          <el-form-item label="医生端是否可见" prop="is_show_doctor">
            <el-radio-group v-model="ruleForm.is_show_doctor">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="图片上传:"
            class="icon_img"
            style="display: block"
            prop="pic"
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px">
              <upload-img
                v-for="(item, index) in ruleForm.oil_thumb_info"
                :key="index"
                :f_thumb="item.oil_thumb"
                :f_thumb_str="item.oil_thumb_str"
                :index="index"
                @emitImg="emitImg"
              ></upload-img>
            </div>
          </el-form-item>

          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="在养生方列表中显示，对功效等简述"
                placement="top"
              >
                <span style="cursor: pointer">
                  <span>养生方描述</span>
                  <i class="el-icon-warning-outline"></i>
                </span>
              </el-tooltip>
            </span>
            <el-input
              v-model="ruleForm.oil_desc"
              placeholder="请输入"
              class="myinput"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="在养生方详情中显示"
                placement="top"
              >
                <span style="cursor: pointer">
                  <span>适应症</span>
                  <i class="el-icon-warning-outline"></i>
                </span>
              </el-tooltip>
            </span>
            <el-input
              v-model="ruleForm.oil_disease"
              placeholder="请输入"
              class="myinput"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <el-tooltip
                class="item"
                effect="dark"
                content="在养生方详情中显示，对养生方成分进行简要说明"
                placement="top"
              >
                <span style="cursor: pointer">
                  <span>配方</span>
                  <i class="el-icon-warning-outline"></i>
                </span>
              </el-tooltip>
            </span>
            <el-input
              v-model="ruleForm.oil_recipe"
              placeholder="请输入"
              class="myinput"
              style="width: 760px"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="用法用量">
            <el-input
              v-model="ruleForm.oil_method"
              placeholder="请输入"
              class="myinput"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="贮藏">
            <el-input
              v-model="ruleForm.oil_storage"
              placeholder="请输入"
              class="myinput"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="补充说明"
            prop="oil_more_desc"
            class="oil-more-desc"
          >
            <el-input
              v-model="ruleForm.oil_more_desc"
              type="textarea"
              :rows="3"
              style="width: 700px"
              placeholder="请输入"
              maxlength="1000"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="养生方详情"
            class="icon_img"
            style="display: block"
            prop="oil_info_image_info"
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px">
              <upload-img
                v-for="(item, index) in ruleForm.oil_info_image_info"
                :key="index"
                :f_thumb="item.oil_info_image"
                :f_thumb_str="item.oil_info_image_str"
                :index="index"
                @emitImg="emitDetailImg"
              ></upload-img>
            </div>
          </el-form-item>

          <!-- 药品信息 -->
          <div class="medicine-table">
            <p>
              <span slot="label">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="养生方的处方详情，供平台备案用。"
                  placement="top"
                >
                  <span style="cursor: pointer" class="itemtitle">
                    药材列表
                    <i
                      class="el-icon-warning-outline"
                      style="margin-left: 6px"
                    ></i>
                  </span>
                </el-tooltip>
              </span>
            </p>
            <div class="medicine-box flex wrap align-center">
              <div
                class="item flex between align-center"
                v-for="(item, index) in ruleForm.medicine"
                :key="index"
              >
                <el-select
                  v-model="item.generic_name"
                  placeholder="添加中药/简拼"
                  class="name-input"
                  clearable
                  filterable
                  remote
                  :remote-method="remoteMedicine"
                  value-key="generic_name"
                  @change="(item) => selectMedicine(item, index)"
                  @blur="changeMedicine(item)"
                  @clear="(item) => clearMedicine(item, index)"
                >
                  <i slot="prefix" class="el-input__icon el-icon-plus" />
                  <el-option
                    v-for="item in drug_remote_list"
                    :key="item.drug_id"
                    :label="item.generic_name"
                    :value="item"
                  />
                </el-select>
                <div class="count-input" v-show="item.drug_id">
                  <el-input-number
                    v-model="item.item_use_level"
                    :min="1"
                    size="mini"
                    :step="1"
                    :controls="false"
                    step-strictly
                  ></el-input-number
                  >g
                </div>
                <div class="use-input" v-show="item.drug_id">
                  <el-select
                    v-model="item.requirement"
                    placeholder="煎法"
                    size="mini"
                    clearable
                  >
                    <el-option
                      v-for="item in medicineUseList"
                      :key="item.decocting_name"
                      :label="item.decocting_name"
                      :value="item.decocting_name"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="itemtitle">库存信息</div>
          <el-form-item label="理论库存">
            <el-input-number
              class="myinput"
              v-model="ruleForm.stock"
              :min="0"
              :max="999999"
              :controls="false"
              step-strictly
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="stock_warning" label="库存预警值">
            <el-input-number
              class="myinput"
              v-model="ruleForm.stock_warning"
              :min="0"
              :max="999999"
              :controls="false"
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="
          text-align: right;
          padding: 0 58px 20px 0;
          box-sizing: border-box;
        "
      >
        <el-button @click="close" style="width: 92px">取 消</el-button>
        <el-button type="primary" @click="submit" style="width: 92px"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadImg from "../../../components/uploadImg";
export default {
  name: "addDrugs",
  components: {
    UploadImg,
  },
  data() {
    let checkCostPrice = (rule, value, callback) => {
      if (value != "") {
        if (this.ruleForm.cost_price != "") {
          // if (Number(value) <= Number(this.ruleForm.cost_price)) {
          //   callback(new Error("销售价须大于成本价"));
          // } else {
          //   callback();
          // }
          callback();
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };

    let checkPrice = (rule, value, callback) => {
      if (value != "") {
        if (this.ruleForm.price != "") {
          // if (Number(value) >= Number(this.ruleForm.price)) {
          //   callback(new Error("成本价须小于销售价"));
          // } else {
          //   callback();
          // }
          callback();
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      dialogShow: true,
      loading: false,
      ruleForm: {
        oil_id: "",
        oil_code: "",
        oil_name: "",
        oil_spec: "",
        oil_unit: "",
        weight: 1,
        cost_price: "",
        price: "",
        stock: undefined,
        oil_desc: "",
        oil_disease: "",
        oil_recipe: "",
        oil_method: "",
        oil_storage: "",
        stock_warning: undefined,
        is_show_doctor: 1,
        oil_more_desc: "",
        oil_info_image_info: [{ oil_info_image: "", oil_info_image_str: "" }],
        category_id: [],
        oil_thumb_info: [
          {
            oil_thumb: "",
            oil_thumb_str: "",
          },
        ],
        medicine: [
          {
            drug_id: "",
            generic_name: "",
            item_use_level: undefined,
            requirement: "",
          },
          {
            drug_id: "",
            generic_name: "",
            item_use_level: undefined,
            requirement: "",
          },
          {
            drug_id: "",
            generic_name: "",
            item_use_level: undefined,
            requirement: "",
          },
        ],
      },
      medicineUseList: [],
      drug_remote_list: [],
      categoryList: [],
      rules: {
        oil_name: [
          { required: true, message: "请输入名称", trigger: "change" },
        ],
        weight: [{ required: true, message: "请输入重量", trigger: "change" }],
        price: [
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },

          { required: true, message: "请输入销售价", trigger: "blur" },
        ],
        cost_price: [
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },
          { required: true, message: "请输入成本价", trigger: "blur" },
        ],
        category_id: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        is_show_doctor: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
    };
  },
  props: ["oil_id", "hospitalName"],
  created() {
    this.getMedicineOintmentCategory();
    this.getSystemDecocting();
    this.getOintmentInfo();
  },
  watch: {
    "ruleForm.medicine": {
      handler(newValue, oldValue) {
        //添加新的格子
        let type = true;
        this.ruleForm.medicine.forEach((ele) => {
          if (!ele.generic_name) {
            type = false;
          }
        });
        if (type) {
          let count = 3 - (newValue.length % 3);
          count = count == 0 ? 3 : count;
          let arr = [];
          for (let i = 0; i < count; i++) {
            arr.push({
              drug_id: "",
              generic_name: "",
              item_use_level: undefined,
              requirement: "",
            });
          }
          this.ruleForm.medicine = this.ruleForm.medicine.concat(arr);
        }
        //如果倒数第四个位置没有药品 删除最后三个空格子
        let length = this.ruleForm.medicine.length;
        if (length > 5 && !this.ruleForm.medicine[length - 4].drug_id) {
          this.ruleForm.medicine.splice(length - 3, 3);
        }
      },
      deep: true,
    },
  },
  methods: {
    //远程搜索药品
    remoteMedicine(name) {
      if (!name) {
        return;
      }
      let data = {
        keywords: name,
      };
      this.axios.post("platform/goods/getDrugList", data).then((res) => {
        this.drug_remote_list = res.data.list;
      });
    },
    //获取煎法
    getSystemDecocting() {
      this.axios.post("platform/template/getSystemDecocting").then((res) => {
        this.medicineUseList = res.data.list;
      });
    },
    changeStock(e) {
      this.$set(this.ruleForm, "stock", e);
    },
    //选择药品
    selectMedicine(item, index) {
      if (!item.drug_id) return;
      let obj = {
        drug_id: item.drug_id,
        generic_name: item.generic_name,
        item_use_level: undefined,
        requirement: "",
      };

      let medicine = JSON.parse(JSON.stringify(this.ruleForm.medicine));
      let repetition = medicine.find((ele) => {
        return ele.generic_name && ele.generic_name == item.generic_name;
      });
      //暂时用空位占据
      this.ruleForm.medicine.splice(index, 1, {
        drug_id: "",
        generic_name: "",
        item_use_level: undefined,
        requirement: "",
      });
      if (repetition && repetition.drug_id) {
        //重复不能添加
        this.$message({
          message: item.generic_name + "已经填写！",
          type: "error",
        });
      } else {
        //添加到第一个没有填写的格子
        let setIndex = this.ruleForm.medicine.findIndex((ele) => {
          return !ele.drug_id;
        });
        this.ruleForm.medicine.splice(setIndex, 1, obj);
      }
    },
    //失去焦点后判断药品是否正确
    changeMedicine(item) {
      let drug = this.drug_remote_list.find((ele) => {
        if (ele.drug_id == item.drug_id) {
          return ele;
        }
      });
      if (drug) {
        item.generic_name = drug.generic_name;
      }
    },
    //清空药品
    clearMedicine(item, index) {
      this.ruleForm.medicine.splice(index, 1);
      this.ruleForm.medicine.push({
        drug_id: "",
        generic_name: "",
        item_use_level: undefined,
        requirement: "",
      });
    },
    // 检验提交的信息
    checkInfo() {
      return new Promise((resolve, reject) => {
        let checked = false;
        this.$refs.ruleForm.validate((valid) => {
          checked = valid;
        });
        if (!checked) {
          reject();
          return;
        }
        let items = this.ruleForm.medicine.filter((ele) => {
          return ele.drug_id;
        });

        try {
          items.forEach((ele) => {
            if (!ele.item_use_level) {
              throw Error();
            }
          });
        } catch (e) {
          this.$message.error("有药品没有输入数量");
          reject();
          return;
        }
        resolve(items);
      });
    },
    // 获取配方（缩略图）图片
    emitDetailImg(data, index, isDel) {
      const obj = {
        oil_info_image: data.pic,
        oil_info_image_str: data.path,
      };
      if (!isDel) {
        this.ruleForm.oil_info_image_info.unshift(obj);
      } else {
        this.ruleForm.oil_info_image_info.splice(index, 1);
      }
    },
    emitImg(data, index, isDel) {
      let obj = {
        oil_thumb: data.pic,
        oil_thumb_str: data.path,
      };
      if (!isDel) {
        this.ruleForm.oil_thumb_info.unshift(obj);
      } else {
        this.ruleForm.oil_thumb_info.splice(index, 1);
      }
    },
    //提交
    submit() {
      this.checkInfo()
        .then((items) => {
          let data = {
            oil_id: this.ruleForm.oil_id,
            hospital_id: this.ruleForm.hospital_id,
            oil_code: this.ruleForm.oil_code,
            oil_name: this.ruleForm.oil_name,
            oil_spec: this.ruleForm.oil_spec,
            oil_unit: this.ruleForm.oil_unit,
            price: this.ruleForm.price,
            cost_price: this.ruleForm.cost_price,
            weight: this.ruleForm.weight,
            stock: this.ruleForm.stock,
            oil_desc: this.ruleForm.oil_desc,
            oil_disease: this.ruleForm.oil_disease,
            oil_recipe: this.ruleForm.oil_recipe,
            oil_method: this.ruleForm.oil_method,
            oil_storage: this.ruleForm.oil_storage,
            stock_warning: this.ruleForm.stock_warning,
            category_id: this.ruleForm.category_id.join(","),
            content: items,
            is_show_doctor: this.ruleForm.is_show_doctor,
            oil_more_desc: this.ruleForm.oil_more_desc,
          };
          const oil_thumb_result = _.chain(this.ruleForm.oil_thumb_info)
            .map("oil_thumb")
            .filter((thumb) => thumb)
            .join(",")
            .value();
          data.oil_thumb = oil_thumb_result;
          // 养生方详情图片（可多张）
          const oil_info_imgs = _.chain(this.ruleForm.oil_info_image_info)
            .map("oil_info_image")
            .filter((img) => img)
            .join(",")
            .value();
          if (oil_info_imgs) {
            data.oil_info_image = oil_info_imgs;
          }
          return this.axios.post("platform/Goods/submitHospitalOintment", data);
        })
        .then((res) => {
          this.$message.success("提交成功");
          this.close();
        });
    },
    getOintmentInfo() {
      let data = {
        oil_id: this.oil_id,
      };
      this.axios
        .post("platform/Goods/getHospitalOintmentInfo", data)
        .then((res) => {
          let info = res.data.info;
          info.medicine = info.content;
          this.ruleForm = info;
          this.ruleForm.category_id = info.category_id
            .split(",")
            .map((item) => Number(item));

          this.ruleForm.oil_thumb_info = _.zipWith(
            info.oil_thumb,
            info.oil_thumb_str,
            (thumb, str) => ({ oil_thumb: thumb, oil_thumb_str: str })
          );

          this.ruleForm.oil_thumb_info.push({
            oil_thumb: "",
            oil_thumb_str: "",
          });

          this.ruleForm.oil_info_image_info = _.zipWith(
            info.oil_info_image,
            info.oil_info_image_str,
            (img, str) => ({ oil_info_image: img, oil_info_image_str: str })
          );

          this.ruleForm.oil_info_image_info.push({
            oil_info_image: "",
            oil_info_image_str: "",
          });
        });
    },
    //获取养生方分类
    getMedicineOintmentCategory() {
      let data = { type: 1 };
      this.axios
        .post("platform/Goods/getMedicineOintmentCategory", data)
        .then((res) => {
          this.categoryList = res.data.list;
        });
    },
    //关闭
    close() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="scss" scoped>
.myform {
  padding: 20px 30px;
  box-sizing: border-box;
  .icon_img {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
  .oil-more-desc {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
}
.itemtitle {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
}
.myinput {
  width: 300px;
}
.content {
  height: 75vh;
  overflow: auto;
}
.medicine-table {
  margin-bottom: 20px;
  width: 910px;
  .top {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #c4cbd9;
    background-color: #f6f6f6;
    line-height: 40px;
    padding-left: 10px;
    font-weight: 600;
  }
}
.medicine-info {
  margin-top: 10px;
  padding: 5px;
  padding-left: 10px;
  border-radius: 2px;
  border: solid 1px #c4cbd9;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
  font-size: 12px;
  div {
    margin: 0 10px;
  }
  .el-input-number {
    width: 60px;
  }
}
</style>
<style lang="scss">
.el-select-dropdown {
  z-index: 99999 !important;
}
.el-tooltip__popper {
  z-index: 99999 !important;
}
.medicine-box {
  .item {
    border: 1px solid #c4cbd9;
    width: 303px;
    box-sizing: border-box;
    &:nth-of-type(3n + 2),
    &:nth-of-type(3n + 3) {
      border-left: none;
    }
    &:nth-of-type(n + 4) {
      border-top: none;
    }
    .name-input {
      flex: 1;
      input {
        border-radius: 0%;
        border-color: transparent;
        &:focus {
          border-color: #1890ff;
        }
      }
    }
    .count-input {
      width: 90px;
      margin-right: 5px;
      .el-input-number {
        width: 40px;
        margin-right: 10px;
      }
      &.max input {
        border: 1px solid #ff514b;
      }
      input {
        border-radius: 0%;
        padding: 0;
        padding-left: 10px;
        box-sizing: border-box;
      }
    }
    .use-input {
      width: 80px;
      margin-right: 5px;
      input {
        border-radius: 0%;
      }
    }
  }
}
</style>